// ============================================
// ФОРМА ЗАПИСИ НА ПРОБНЫЙ ДЕНЬ ДЛЯ ДЕТСКОГО САДА
// ============================================

// Инициализация Phone Flag Selector для формы детского сада (как на главной странице)
(function() {
  function init() {
  const initTrialDayPhoneFlagSelector = () => {
    const phoneFlagSelectorTrialDay = document.getElementById("phoneFlagSelector_trial_day");
    const phoneModalTrialDay = document.getElementById("phoneModal_trial_day");
    
    // Проверяем, что элементы существуют
    if (!phoneFlagSelectorTrialDay || !phoneModalTrialDay) {
      return;
    }
    
    // Проверяем, что функция инициализации доступна
    if (!window.initPhoneFlagSelector) {
      // Ждем загрузки функции
      setTimeout(initTrialDayPhoneFlagSelector, 100);
      return;
    }
    
    // Ждем загрузки данных стран, если они еще не загружены
    if (!window.countryCodesData) {
      setTimeout(() => {
        if (window.initPhoneFlagSelector && window.countryCodesData) {
          window.initPhoneFlagSelector({
            selectorId: "phoneFlagSelector_trial_day",
            modalId: "phoneModal_trial_day",
            flagImgId: "phoneFlagImg_trial_day",
            codeId: "phoneCode_trial_day",
            commentId: "comment_trial_day"
          });
          // Убеждаемся, что кнопка закрытия есть
          const phoneModalTrialDay = document.getElementById("phoneModal_trial_day");
          if (phoneModalTrialDay && typeof window.ensureCloseButtonInHeader === 'function') {
            window.ensureCloseButtonInHeader(phoneModalTrialDay);
          }
        }
      }, 200);
    } else {
      window.initPhoneFlagSelector({
        selectorId: "phoneFlagSelector_trial_day",
        modalId: "phoneModal_trial_day",
        flagImgId: "phoneFlagImg_trial_day",
        codeId: "phoneCode_trial_day",
        commentId: "comment_trial_day"
      });
      // Убеждаемся, что кнопка закрытия есть
      const phoneModalTrialDay = document.getElementById("phoneModal_trial_day");
      if (phoneModalTrialDay && typeof window.ensureCloseButtonInHeader === 'function') {
        window.ensureCloseButtonInHeader(phoneModalTrialDay);
      }
    }
  };
  
  // Вызываем инициализацию с небольшой задержкой
  setTimeout(initTrialDayPhoneFlagSelector, 100);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// Инициализация формы после загрузки DOM
(function() {
  function init() {
  // Небольшая задержка для загрузки всех скриптов
  setTimeout(() => {
    initTrialDayForm();
  }, 100);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

function initTrialDayForm() {
  // Элементы первой страницы формы
  const phoneTrialDay = document.getElementById('phone_trial_day');
  const commentTrialDay = document.getElementById('comment_trial_day');
  const submitBtnTrialDay = document.getElementById('submitBtn_trial_day');
  const antibotLabelTrialDay = document.getElementById('antibotLabel_trial_day');

  if (!phoneTrialDay || !commentTrialDay || !submitBtnTrialDay) {
    return; // Форма не найдена на странице
  }

  // Объявляем функции один раз
  const updateSubmitButtonFn =
    window.updateSubmitButton ||
    (typeof updateSubmitButton === 'function' ? updateSubmitButton : null);

  // Генерируем антибот
  const generateAntibotFn =
    window.generateAntibot ||
    (typeof generateAntibot === 'function' ? generateAntibot : null);
  const updateAntibotLabelFn =
    window.updateAntibotLabel ||
    (typeof updateAntibotLabel === 'function' ? updateAntibotLabel : null);
  
  if (typeof generateAntibotFn !== 'function') {
    return;
  }
  let antibotTrialDay = generateAntibotFn();
  if (antibotLabelTrialDay && typeof updateAntibotLabelFn === 'function') {
    updateAntibotLabelFn(antibotLabelTrialDay, antibotTrialDay);
  }

  let itiTrialDay = null;

  // Инициализация intlTelInput для телефона
  if (window.intlTelInput) {
    // Определяем регион при загрузке страницы
    let initialCountry = "ru";
    try {
      const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined') 
        ? window.getCookie(window.COOKIE_NAME) 
        : null;
      if (saved) {
        const r = JSON.parse(saved);
        if (r.name === 'Узбекистан' || r.name === 'Uzbekistan') {
          initialCountry = "uz";
        }
      }
    } catch (e) {
      // Используем значение по умолчанию
    }
    
    itiTrialDay = window.intlTelInput(phoneTrialDay, {
      initialCountry: initialCountry,
      preferredCountries: ["ru", "uz"],
      nationalMode: false,
      formatOnDisplay: true,
      allowDropdown: false,
      separateDialCode: false,
      utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.6/build/js/utils.js",
    });
    
    phoneTrialDay._iti = itiTrialDay;
    
    const setCorrectPlaceholder = () => {
      if (itiTrialDay && phoneTrialDay) {
        try {
          const countryData = itiTrialDay.getSelectedCountryData();
          const countryCode = countryData ? countryData.dialCode : null;
          if (countryCode) {
            const country = window.getCountryByCode && window.getCountryByCode('+' + countryCode);
            if (country && country.placeholder) {
              phoneTrialDay.dataset.correctPlaceholder = country.placeholder;
              return country.placeholder;
            }
          }
        } catch (e) {
          // intl-tel-input еще не готов
        }
      }
      return null;
    };
    
    const originalSetAttribute = Element.prototype.setAttribute.bind(phoneTrialDay);
    phoneTrialDay.setAttribute = function(name, value) {
      if (name === 'placeholder') {
        const correctPlaceholder = this.dataset.correctPlaceholder;
        if (correctPlaceholder) {
          Element.prototype.setAttribute.call(this, name, correctPlaceholder);
        } else {
          originalSetAttribute.call(this, name, value);
        }
      } else {
        originalSetAttribute.call(this, name, value);
      }
    };
    
    let correctPlaceholderValue = null;
    Object.defineProperty(phoneTrialDay, 'placeholder', {
      get: function() {
        return correctPlaceholderValue || this.getAttribute('placeholder') || '';
      },
      set: function(value) {
        const correctPlaceholder = this.dataset.correctPlaceholder;
        if (correctPlaceholder) {
          correctPlaceholderValue = correctPlaceholder;
          Element.prototype.setAttribute.call(this, 'placeholder', correctPlaceholder);
        } else {
          correctPlaceholderValue = value;
          Element.prototype.setAttribute.call(this, 'placeholder', value);
        }
      },
      configurable: true,
      enumerable: true
    });
    
    const updatePhoneTrialDayPlaceholder = () => {
      const placeholder = setCorrectPlaceholder();
      if (placeholder) {
        phoneTrialDay.placeholder = placeholder;
      }
    };
    
    setTimeout(() => updatePhoneTrialDayPlaceholder(), 300);
    setTimeout(() => updatePhoneTrialDayPlaceholder(), 800);
    setTimeout(() => updatePhoneTrialDayPlaceholder(), 1500);
    setTimeout(() => updatePhoneTrialDayPlaceholder(), 2500);
    setTimeout(() => updatePhoneTrialDayPlaceholder(), 4000);
    
    const placeholderCheckInterval = setInterval(() => {
      const correctPlaceholder = phoneTrialDay.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        const currentPlaceholder = phoneTrialDay.getAttribute('placeholder');
        if (currentPlaceholder !== correctPlaceholder) {
          phoneTrialDay.placeholder = correctPlaceholder;
        }
      }
    }, 300);
    
    setTimeout(() => {
      clearInterval(placeholderCheckInterval);
    }, 15000);
    
    if (typeof updateSubmitButtonFn === 'function') {
      phoneTrialDay.addEventListener('input', () => {
        updateSubmitButtonFn(phoneTrialDay, commentTrialDay, submitBtnTrialDay, itiTrialDay, antibotTrialDay.answer);
      });
      
      phoneTrialDay.addEventListener('blur', () => {
        updateSubmitButtonFn(phoneTrialDay, commentTrialDay, submitBtnTrialDay, itiTrialDay, antibotTrialDay.answer);
      });
      
      phoneTrialDay.addEventListener('countrychange', () => {
        updatePhoneTrialDayPlaceholder();
        updateSubmitButtonFn(phoneTrialDay, commentTrialDay, submitBtnTrialDay, itiTrialDay, antibotTrialDay.answer);
      });
    }
  }

  if (commentTrialDay && submitBtnTrialDay && typeof updateSubmitButtonFn === 'function') {
    commentTrialDay.addEventListener('input', () => {
      updateSubmitButtonFn(phoneTrialDay, commentTrialDay, submitBtnTrialDay, itiTrialDay, antibotTrialDay.answer);
    });
    
    commentTrialDay.addEventListener('blur', () => {
      updateSubmitButtonFn(phoneTrialDay, commentTrialDay, submitBtnTrialDay, itiTrialDay, antibotTrialDay.answer);
    });
  }

  if (typeof updateSubmitButtonFn === 'function') {
    setTimeout(() => {
      if (itiTrialDay) {
        updateSubmitButtonFn(phoneTrialDay, commentTrialDay, submitBtnTrialDay, itiTrialDay, antibotTrialDay.answer);
      } else {
        updateSubmitButtonFn(phoneTrialDay, commentTrialDay, submitBtnTrialDay, null, antibotTrialDay.answer);
      }
    }, 1000);
  }

  if (submitBtnTrialDay) {
    submitBtnTrialDay.addEventListener('click', (e) => {
      e.preventDefault();
      
      const validatePhoneFn =
        window.validatePhone ||
        (typeof validatePhone === 'function' ? validatePhone : null);
      const checkAntibotFn =
        window.checkAntibot ||
        (typeof checkAntibot === 'function' ? checkAntibot : null);
      const generateAntibotFn =
        window.generateAntibot ||
        (typeof generateAntibot === 'function' ? generateAntibot : null);
      const updateAntibotLabelFn =
        window.updateAntibotLabel ||
        (typeof updateAntibotLabel === 'function' ? updateAntibotLabel : null);
      const updateSubmitButtonFn =
        window.updateSubmitButton ||
        (typeof updateSubmitButton === 'function' ? updateSubmitButton : null);
      
      if (typeof validatePhoneFn !== 'function') {
        return;
      }
      
      if (!validatePhoneFn(phoneTrialDay, itiTrialDay)) {
        alert('Пожалуйста, введите корректный номер телефона');
        return;
      }
      
      if (typeof checkAntibotFn !== 'function') {
        return;
      }
      
      if (!checkAntibotFn(commentTrialDay.value, antibotTrialDay.answer)) {
        alert('Неверный ответ на вопрос антибота');
        antibotTrialDay = generateAntibotFn();
        if (antibotLabelTrialDay && typeof updateAntibotLabelFn === 'function') {
          updateAntibotLabelFn(antibotLabelTrialDay, antibotTrialDay);
        }
        commentTrialDay.value = '';
        if (typeof updateSubmitButtonFn === 'function') {
          updateSubmitButtonFn(phoneTrialDay, commentTrialDay, submitBtnTrialDay, itiTrialDay, antibotTrialDay.answer);
        }
        return;
      }
      
      const formStep1TrialDay = document.querySelector('.trial-day-form .form_hover');
      const formStep2TrialDay = document.getElementById('formStep2_trial_day');
      const phoneStep2TrialDay = document.getElementById('phone_step2_trial_day');
      
      if (formStep1TrialDay && formStep2TrialDay && phoneStep2TrialDay) {
        let phoneNumber = '';
        if (phoneTrialDay && phoneTrialDay.value) {
          const digits = phoneTrialDay.value.replace(/\D/g, '');
          if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
            phoneNumber = digits.substring(1);
          } else if (digits.length > 0 && digits[0] === '9') {
            phoneNumber = digits;
          } else {
            phoneNumber = digits;
          }
        }
        
        phoneStep2TrialDay.value = phoneNumber;
        
        const phoneCodeTrialDay = document.getElementById('phoneCode_trial_day')?.textContent || '+7';
        const phoneFlagImgTrialDay = document.getElementById('phoneFlagImg_trial_day');
        const phoneCodeStep2TrialDay = document.getElementById('phoneCode_step2_trial_day');
        const phoneFlagImgStep2TrialDay = document.getElementById('phoneFlagImg_step2_trial_day');
        
        if (phoneCodeStep2TrialDay) phoneCodeStep2TrialDay.textContent = phoneCodeTrialDay;
        if (phoneFlagImgStep2TrialDay && phoneFlagImgTrialDay) {
          const clonedFlag = phoneFlagImgTrialDay.cloneNode(true);
          clonedFlag.id = phoneFlagImgStep2TrialDay.id;
          phoneFlagImgStep2TrialDay.replaceWith(clonedFlag);
        }

        if (phoneStep2TrialDay) {
          phoneStep2TrialDay.dataset.countryCode = phoneCodeTrialDay;
          if (typeof window.formatPhoneNumber === 'function') {
            phoneStep2TrialDay.value = window.formatPhoneNumber(phoneNumber, phoneCodeTrialDay);
          }
        }
        
        formStep1TrialDay.style.display = 'none';
        formStep2TrialDay.style.display = 'flex';
        
        setTimeout(() => {
          if (window.initPhoneFlagSelectorStep2) {
            window.initPhoneFlagSelectorStep2('phoneFlagSelector_step2_trial_day', 'phoneModal_step2_trial_day', 'phoneFlagImg_step2_trial_day', 'phoneCode_step2_trial_day');
          } else if (window.initPhoneFlagSelector) {
            window.initPhoneFlagSelector({
              selectorId: "phoneFlagSelector_step2_trial_day",
              modalId: "phoneModal_step2_trial_day",
              flagImgId: "phoneFlagImg_step2_trial_day",
              codeId: "phoneCode_step2_trial_day",
              commentSelector: '.form_hover_step2'
            });
            const phoneModalStep2 = document.getElementById('phoneModal_step2_trial_day');
            if (phoneModalStep2 && typeof window.ensureCloseButtonInHeader === 'function') {
              window.ensureCloseButtonInHeader(phoneModalStep2);
            }
          }
        }, 100);
        
        if (typeof window.translateStep2Form === 'function') {
          window.translateStep2Form('formStep2_trial_day');
        }

        if (phoneStep2TrialDay) {
          phoneStep2TrialDay.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    });
  }

  initTrialDayFormStep2();
}

function getDefaultCampusForKindergarten() {
  const pathMatch = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})\//);
  if (pathMatch && pathMatch[2] === 'uz') return 'tashkent';
  try {
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME) : null;
    if (saved) {
      const r = JSON.parse(saved);
      if (r.name === 'Узбекистан' || r.name === 'Uzbekistan') return 'tashkent';
    }
  } catch (e) {}
  const curCountry = document.getElementById('curCountry');
  if (curCountry && (curCountry.textContent.trim() === 'Узбекистан' || curCountry.textContent.trim() === 'Uzbekistan')) return 'tashkent';
  return 'skolkovo';
}

function initTrialDayFormStep2() {
  const emailTrialDay = document.getElementById('email_trial_day');
  const birthDateTrialDay = document.getElementById('birth_date_trial_day');
  const campusTrialDay = document.getElementById('campus_trial_day');
  const campusImageTrialDay = document.getElementById('campusImage_trial_day');
  const campusCaptionTrialDay = document.getElementById('campusCaption_trial_day');
  const campusImageTrialDayDesktop = document.getElementById('campusImage_trial_day_desktop');
  const campusCaptionTrialDayDesktop = document.getElementById('campusCaption_trial_day_desktop');
  const submitStep2TrialDay = document.getElementById('submitStep2_trial_day');

  const validateEmailFn =
    window.validateEmail ||
    (typeof validateEmail === 'function' ? validateEmail : null);
  if (emailTrialDay && typeof validateEmailFn === 'function') {
    emailTrialDay.addEventListener('input', () => {
      if (emailTrialDay.value && validateEmailFn(emailTrialDay.value)) {
        emailTrialDay.classList.remove('error');
      }
    });
    emailTrialDay.addEventListener('blur', () => {
      if (emailTrialDay.value && !validateEmailFn(emailTrialDay.value)) {
        emailTrialDay.classList.add('error');
      } else {
        emailTrialDay.classList.remove('error');
      }
    });
  }

  const validateBirthDateFn =
    window.validateBirthDate ||
    (typeof validateBirthDate === 'function' ? validateBirthDate : null);
  if (birthDateTrialDay && typeof validateBirthDateFn === 'function') {
    birthDateTrialDay.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length >= 2) {
        value = value.slice(0, 2) + '.' + value.slice(2);
      }
      if (value.length >= 5) {
        value = value.slice(0, 5) + '.' + value.slice(5, 9);
      }
      e.target.value = value;
    });
    
    birthDateTrialDay.addEventListener('input', () => {
      if (birthDateTrialDay.value && validateBirthDateFn(birthDateTrialDay.value)) {
        birthDateTrialDay.classList.remove('error');
      }
    });
    birthDateTrialDay.addEventListener('blur', () => {
      if (birthDateTrialDay.value && !validateBirthDateFn(birthDateTrialDay.value)) {
        birthDateTrialDay.classList.add('error');
      } else {
        birthDateTrialDay.classList.remove('error');
      }
    });
  }

  if (campusTrialDay && campusImageTrialDay) {
    const imgBase = '/landing_2025/src/img/';
    const campusImages = {
      skolkovo: imgBase + 'Campus_1.webp',
      moscow: imgBase + 'Campus_2.webp',
      gorki: imgBase + 'Campus_3.webp',
      spb: imgBase + 'Campus_4.webp',
      tashkent: imgBase + 'Campus_5.webp'
    };

    const campusCaptions = {
      skolkovo: 'Кампус Сколково',
      moscow: 'Кампус Москва',
      gorki: 'Кампус Горки',
      spb: 'Кампус Санкт-Петербург',
      tashkent: 'Кампус Ташкент'
    };

    const form = campusTrialDay.closest('form');
    const campusIds = form && form.dataset.campusIds ? JSON.parse(form.dataset.campusIds) : {};
    const campusIdToSlug = {};
    Object.keys(campusIds || {}).forEach(slug => { campusIdToSlug[String(campusIds[slug])] = slug; });
    const defaultCampusSlug = getDefaultCampusForKindergarten();
    const defaultCampusId = campusIds[defaultCampusSlug];
    if (!campusTrialDay.value && defaultCampusId) {
      campusTrialDay.value = String(defaultCampusId);
    }
    campusTrialDay.addEventListener('change', () => {
      const campusSlug = campusIdToSlug[campusTrialDay.value] || defaultCampusSlug;
      const campus = campusSlug;
      if (campusImages[campus]) {
        campusImageTrialDay.src = campusImages[campus];
        if (campusImageTrialDayDesktop) {
          campusImageTrialDayDesktop.src = campusImages[campus];
        }
      }
      if (campusCaptions[campus]) {
        if (campusCaptionTrialDay) {
          campusCaptionTrialDay.textContent = campusCaptions[campus];
        }
        if (campusCaptionTrialDayDesktop) {
          campusCaptionTrialDayDesktop.textContent = campusCaptions[campus];
        }
      }
    });
    
    const initialCampusSlug = campusIdToSlug[campusTrialDay.value] || defaultCampusSlug;
    if (campusImages[initialCampusSlug]) {
      campusImageTrialDay.src = campusImages[initialCampusSlug];
      if (campusImageTrialDayDesktop) {
        campusImageTrialDayDesktop.src = campusImages[initialCampusSlug];
      }
    }
    if (campusCaptions[initialCampusSlug]) {
      if (campusCaptionTrialDay) {
        campusCaptionTrialDay.textContent = campusCaptions[initialCampusSlug];
      }
      if (campusCaptionTrialDayDesktop) {
        campusCaptionTrialDayDesktop.textContent = campusCaptions[initialCampusSlug];
      }
    }
  }

  const phoneStep2TrialDay = document.getElementById('phone_step2_trial_day');
  if (phoneStep2TrialDay) {
    const applyPhoneFormatting = () => {
      const phoneWrapper = phoneStep2TrialDay.closest('.phone_wrapper');
      const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
      const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
      if (typeof window.formatPhoneNumber === 'function' && phoneStep2TrialDay.value) {
        phoneStep2TrialDay.value = window.formatPhoneNumber(phoneStep2TrialDay.value, code);
      }
      phoneStep2TrialDay.dataset.countryCode = code;
    };

    phoneStep2TrialDay.addEventListener('input', () => {
      applyPhoneFormatting();
      const phoneWrapper = phoneStep2TrialDay.closest('.phone_wrapper');
      const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
      const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
      if (window.validatePhoneNumber && phoneStep2TrialDay.value.trim()) {
        const validation = window.validatePhoneNumber(phoneStep2TrialDay.value, code);
        if (validation.valid) {
          phoneStep2TrialDay.classList.remove('error');
        }
      }
    });
    phoneStep2TrialDay.addEventListener('blur', applyPhoneFormatting);
    applyPhoneFormatting();
  }

  const parentNameTrialDay = document.getElementById('parent_name_trial_day');
  if (parentNameTrialDay) {
    parentNameTrialDay.addEventListener('input', () => {
      if (parentNameTrialDay.value) {
        parentNameTrialDay.classList.remove('error');
      }
    });
  }

  const childNameTrialDay = document.getElementById('child_name_trial_day');
  if (childNameTrialDay) {
    childNameTrialDay.addEventListener('input', () => {
      if (childNameTrialDay.value) {
        childNameTrialDay.classList.remove('error');
      }
    });
  }

  if (campusTrialDay) {
    campusTrialDay.addEventListener('change', () => {
      if (campusTrialDay.value) {
        campusTrialDay.classList.remove('error');
      }
    });
  }

  if (submitStep2TrialDay) {
    submitStep2TrialDay.addEventListener('click', (e) => {
      e.preventDefault();
      
      let isValid = true;
      const missingFields = [];
      
      if (phoneStep2TrialDay) {
        const phoneWrapper = phoneStep2TrialDay.closest('.phone_wrapper');
        const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
        const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
        
        if (window.validatePhoneNumber && phoneStep2TrialDay.value.trim()) {
          const validation = window.validatePhoneNumber(phoneStep2TrialDay.value, code);
          if (!validation.valid) {
            phoneStep2TrialDay.classList.add('error');
            isValid = false;
            missingFields.push('Телефон');
          } else {
            phoneStep2TrialDay.classList.remove('error');
          }
        } else if (!phoneStep2TrialDay.value.trim()) {
          phoneStep2TrialDay.classList.add('error');
          isValid = false;
          missingFields.push('Телефон');
        } else {
          phoneStep2TrialDay.classList.remove('error');
        }
      }
      
      const validateEmailFn =
        window.validateEmail ||
        (typeof validateEmail === 'function' ? validateEmail : null);
      if (typeof validateEmailFn !== 'function') {
        return;
      }
      
      if (!emailTrialDay.value || !validateEmailFn(emailTrialDay.value)) {
        emailTrialDay.classList.add('error');
        isValid = false;
        missingFields.push('Email');
      } else {
        emailTrialDay.classList.remove('error');
      }
      
      if (!parentNameTrialDay.value) {
        parentNameTrialDay.classList.add('error');
        isValid = false;
        missingFields.push('Имя и фамилия родителя');
      } else {
        parentNameTrialDay.classList.remove('error');
      }
      
      if (!campusTrialDay.value) {
        campusTrialDay.classList.add('error');
        isValid = false;
        missingFields.push('Кампус');
      } else {
        campusTrialDay.classList.remove('error');
      }
      
      if (!isValid) {
        const message = 'Пожалуйста, заполните обязательные поля: ' + missingFields.join(', ');
        alert(message);
        return;
      }
      
      // Отправка формы как на главной странице
      const form = submitStep2TrialDay.closest('form');
      if (form && typeof window.setFormSubmitting === 'function') {
        window.setFormSubmitting(form, true);
      }
      if (typeof window.submitLandingForm === 'function') {
        window.submitLandingForm(submitStep2TrialDay);
      } else if (form) {
        form.submit();
      }
    });
  }
}
